module.exports = "<div baCardBlur class=\"animated fadeIn card {{cardType}} {{baCardClass || ''}}\" zoom-in>\n    <div *ngIf=\"title\" class=\"card-header clearfix\">\n        <h3 class=\"card-title\" translate>{{title}}</h3>\n    </div>\n    <div class=\"card-body\">\n        <ng-content></ng-content>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baCard/baCard.html
// module id = 782
// module chunks = 14